import { CognitoUser } from '@aws-amplify/auth'
import { getHeaderToken } from '../utils/serviceHelper';
import axios from 'axios';

const App = 'TECHREVIEW';

const getUserGroups = (user: CognitoUser) => {
    if (user) {
        const signInSession = user.getSignInUserSession();

        if (signInSession) {
        const accessToken = signInSession.getAccessToken();

            if (accessToken) {
                return accessToken.payload["cognito:groups"];
            }

        }
    }
    return [];
}

export const getUserHasAccess = (user: CognitoUser): boolean => {
    const userGroups = getUserGroups(user);

    return userGroups.includes(process.env.REACT_APP_TECH_REVIEW_APP_GROUP);
}

export const getUserCapabilities = async (userId: string | undefined) => {
    if (userId) {     
        const url = process.env.REACT_APP_IDWAL_API_ENDPOINT + `/Users/${userId}/Capabilities?app=${App}`;

        const headers = await getHeaderToken();
    
        const data = { userId, app: App };
    
        try {
            const response = await axios.get(url, { headers, data });

            if (response.data.data?.length) {
                return response.data.data;
            } else {
                return [];
            }
        } catch (error) {
            console.warn('Failed to get user capabilities');
            return [];
        }
    }
}